import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import IconPresent from "@components/Images/IconPresent";

const BofuCompletado = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const companyData = useSelector((state: RootState) => state.register.company);

  return (
    <Grid
      container
      height="100%"
      sx={{
        backgroundColor: theme?.palette?.screens?.bofu?.backgroundColor || theme?.palette?.primary?.base,
        color: theme?.palette?.screens?.bofu?.titleColor || theme?.palette?.primary?.dark,
      }}
    >
      <Grid item xs={12} md={8} mt={5}>
        <InactivityHandler />
        <Box mx={4} textAlign="center">
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screens?.bofu?.titleColor || theme?.palette?.primary?.main}
            fontWeight="bold"
          >
            ¡Felicidades!
          </Typography>

          <Typography mt={2} variant={isMobileOrTablet ? "h4" : "h3"} fontWeight="bold">
            {companyData.legal_name || "Nombre de la empresa"}
          </Typography>

          <Box mt={6} display="flex" justifyContent="center">
            <IconPresent fill={theme?.palette?.screens?.bofu?.iconColor || theme.palette.primary.main} />
          </Box>

          <Typography mt={6} variant={isMobileOrTablet ? "body2" : "body1"}>
            Una vez que hayamos revisado que todo este correcto te depositaremos el dinero a tu cuenta, esto puede
            tardar hasta 24 horas
          </Typography>

          <Typography mt={4} variant={isMobileOrTablet ? "body2" : "body1"} fontWeight="bold">
            Nos pondremos en contacto para validar que se realizo tu deposito.
          </Typography>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default BofuCompletado;
